module.exports = __webpack_public_path__ + "static/grown-78fb2949ac35c54b8955e39eb103f194.svg";